import SiteAnalytics from './components/SiteAnalytics/SiteAnalytics';
import SiteSeo from './components/SiteSeo/SiteSeo';
import BlogTopicRoute from './pages/Blog/BlogTopicRoute';
import React from "react";
import "./App.css";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Home from "./pages/Home/Home";
import AboutUs from "./pages/AboutUs/AboutUs";
import ProjectList from "./pages/ProjectList/ProjectList";
import Projects from "./pages/Projects/Projects";
import ContactUs from "./pages/ContactUs/ContactUs";
import NotFound404 from "./pages/404/404";
import ArchivePage from "./pages/Archive/Archive";
import useTranslate from "./hooks/useTranslate";
import BlogPage from "./pages/Blog/Blog";
import BlogDetailsPage from "./pages/BlogDetail/BlogDetails";
import Admin from "./pages/Admin/Admin";
import CategoryProjects from "./pages/CategoryProjects/CategoryProjects";
import ServiceDetail from "./components/ServiceDetail/ServiceDetail";
import HealthSubService from "./components/HealthSubService/HealthSubService";
import LegacyHealthcareRedirect from './components/ServiceDetail/LegacyHealthcareRedirect';
import ResumePage from './components/ServiceDetail/ResumePage';
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Services from "./pages/Services/Services";
import SiteBehavior from "./components/SiteBehavior/SiteBehavior";
import "./SiteLayout.css";

function App() {
  const { language } = useTranslate();
  const currentLanguage = language?.split("-")[0] || "en";

  return (
    <div
      className={`app ${currentLanguage}`}
      lang={currentLanguage}
      dir={currentLanguage === "fa" ? "rtl" : "ltr"}
    >
        <BrowserRouter basename={window.location.pathname.match(/^\/(fa|en)(?:\/|$)/)?.[0].replace(/\/$/, "") || "/"}>
          <SiteBehavior />
          <SiteSeo />
          <SiteAnalytics />
          <Routes>
            <Route path="/">
              <Route index element={<Home />} />
              <Route path="projects">
                <Route index element={<Projects />} />
                <Route path="health/*" element={<LegacyHealthcareRedirect />} />
                <Route path=":category" element={<CategoryProjects />} />
                <Route
                  path=":category/:projectName"
                  element={<ProjectList />}
                />
              </Route>
              <Route path="about-us">
                <Route index element={<AboutUs />} />
              </Route>
              <Route path="team/:personSlug" element={<ResumePage />} />
              <Route path="services">
                <Route index element={<Services />} />
                <Route path="health/*" element={<LegacyHealthcareRedirect />} />
                <Route path="healthcare/health-service-planning" element={<LegacyHealthcareRedirect />} />
                <Route
                  path="healthcare/:subServiceSlug"
                  element={<HealthSubService />}
                />
                <Route
                  path="healthcare/:subServiceSlug/:deptSlug"
                  element={<HealthSubService />}
                />
                <Route path=":serviceSlug" element={<ServiceDetail />} />
              </Route>
              <Route path="contact-us">
                <Route index element={<ContactUs />} />
              </Route>
              <Route path="archive">
                <Route index element={<ArchivePage />} />
              </Route>
              <Route path="blog">
                <Route index element={<BlogPage />} />
                <Route path=":topic/:slug" element={<BlogDetailsPage />} />
                <Route path=":slug" element={<BlogTopicRoute />} />
              </Route>
              <Route path="admin">
                <Route index element={<Admin />} />
              </Route>
            </Route>
            <Route path="*" element={<NotFound404 />} />
          </Routes>
        </BrowserRouter>
      <ToastContainer
        position="top-center"
        autoClose={4000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        rtl={true}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="dark"
        toastStyle={{
          fontFamily:
            currentLanguage === "fa"
              ? "IRANSans, sans-serif"
              : "Inter, sans-serif",
        }}
      />
    </div>
  );
}

export default App;
